module.exports = __webpack_public_path__ + "static/img/6.40d2b94.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/fresh-images/6.jpg
// module id = faIE
// module chunks = 1